import React from 'react';
import '../style/warning.css';
import config from '../config/config.js';

export default class Unauthorised extends React.Component {
    render() {
        console.debug("Config: " + Object.keys(config));
        return (<div className="page-wrap">
            <div className="container">
                <div className="message animated bounceIn">
                    <div className="display-table">
                        <div className="display-table-cell">
                            <svg className="icon icon-left icon-x"></svg>
                        </div>
                        <div className="display-table-cell">
                            <h1>Unauthorised</h1>
                            <p>Go back to <a href={ config.homeUrl }>Home Page</a></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>);
    }
}



// WEBPACK FOOTER //
// ./src/route/Unauthorised.js